module.exports = __webpack_public_path__ + "img/flurries.3053cb83.png";